export default "__VITE_ASSET__D21XZ04E__"